import React from 'react';
import { Link } from 'react-router-dom';

import { BreadcrumbItem } from 'src/types/shared/Breadcrumb';

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, title }) => {
    const itemsLength = items.length;

    return (
        <div className="breadcrumb">
            {items.map(({ name, link }, index) => {
                const isLast = index === itemsLength - 1;

                if (link)
                    return (
                        <span key={index}>
                            <Link to={link}>{name}</Link>
                            {!isLast ? ' / ' : ''}
                        </span>
                    );
                return (
                    <span key={index} className={isLast ? 'active' : ''}>{`${name}${
                        !isLast ? ' / ' : ''
                    }`}</span>
                );
            })}
            {title && <span className="active">{` / ${title}`}</span>}
        </div>
    );
};

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    title?: string;
}

export default Breadcrumb;
